import { MemoryCache } from './memoryCache';
export class LibraryList extends MemoryCache {
    constructor(path) {
        super();
        this.path = path;
        this.getList = () => this.wrapPromise(path, this.fetch.bind(this));
    }
    async fetch() {
        try {
            const res = await window.fetch(this.path);
            if (!res.ok) {
                return null;
            }
            const text = await res.text();
            const list = JSON.parse(text);
            return this.mapImagesToSources(list);
        }
        catch (error) {
            console.log(error); // eslint-disable-line
            throw error;
        }
    }
    mapImagesToSources(list) {
        return list.map((category) => {
            return Object.assign({}, category);
        });
    }
}
